import React from 'react';
import Select from "../../componentsReusable/Select";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";

const branches = [
  {
    branch: 1,
    city: 'Warszawa',
    postalCode: '03-253',
    street: 'ul. Annopol 2D',
    email: 'bialoleka@inter-team.com.pl',
  },
  {
    branch: 2,
    city: 'Lódź',
    postalCode: '92-202',
    street: 'ul. Aleja Piłsudskiego 92',
    email: 'lodz@inter-team.com.pl',
  },
  {
    branch: 3,
    city: 'Opole',
    postalCode: '45-129',
    street: 'ul. Kępska 5C',
    email: 'opole@inter-team.com.pl',
  },
  {
    branch: 4,
    city: 'Reguły',
    postalCode: '05-816',
    street: 'ul. Regulska 41A',
    email: 'warszawa1@inter-team.com.pl',
  },
  {
    branch: 5,
    city: 'Poznań',
    postalCode: '60-650',
    street: 'ul. Obornicka 227',
    email: 'poznan@inter-team.com.pl',
  },
  {
    branch: 6,
    city: 'Katowice',
    postalCode: '40-600',
    street: 'ul. Kościuszki 227',
    email: 'katowice@inter-team.com.pl',
  },
  {
    branch: 8,
    city: 'Warszawa',
    postalCode: '02-707',
    street: 'ul. Puławska 115',
    email: 'warszawa2@inter-team.com.pl',
  },
  {
    branch: 9,
    city: 'Bydgoszcz',
    postalCode: '85-619',
    street: 'ul. Pułaskiego 27',
    email: 'bydgoszcz@inter-team.com.pl',
  },
  {
    branch: 11,
    city: 'Radom',
    postalCode: '26-600',
    street: 'ul. Kapturska 7/9',
    email: 'radom@inter-team.com.pl',
  },
  {
    branch: 12,
    city: 'Szczecin',
    postalCode: '70-132',
    street: 'ul. Ruska 29',
    email: 'szczecin@inter-team.com.pl',
  },
  {
    branch: 14,
    city: 'Kielce',
    postalCode: '25-620',
    street: 'ul. Kolberga 4A',
    email: 'kielce@inter-team.com.pl',
  },
  {
    branch: 15,
    city: 'Pszczyna',
    postalCode: '43-200',
    street: 'ul. Górnośląska 21',
    email: 'pszczyna@inter-team.com.pl',
  },
  {
    branch: 16,
    city: 'Wiązowna',
    postalCode: '05-462',
    street: 'ul. Równa 1 Majdan',
    email: 'majdan@inter-team.com.pl',
  },
  {
    branch: 17,
    city: 'Słubice',
    postalCode: '69-100',
    street: 'ul. Osiedle Przemysłowe 16',
    email: 'slubice@inter-team.com.pl',
  },
  {
    branch: 18,
    city: 'Słupsk',
    postalCode: '76-200',
    street: 'ul. Bohaterów Westerplatte 7',
    email: 'slupsk@inter-team.com.pl',
  },
  {
    branch: 19,
    city: 'Gdańsk',
    postalCode: '80-298',
    street: 'ul. Budowlanych 52a',
    email: 'gdansk@inter-team.com.pl',
  },
  {
    branch: 20,
    city: 'Kwidzyn',
    postalCode: '82-500',
    street: 'ul. 11 Listopada 25',
    email: 'kwidzyn@inter-team.com.pl',
  },
  {
    branch: 21,
    city: 'Olsztyn',
    postalCode: '10-408',
    street: 'ul. Lubelska 36A',
    email: 'olsztyn@inter-team.com.pl',
  },
  {
    branch: 22,
    city: 'Częstochowa',
    postalCode: '42-229',
    street: 'ul. Jesienna 219',
    email: 'czestochowa@inter-team.com.pl',
  },
  {
    branch: 23,
    city: 'Przyszowice',
    postalCode: '44-178',
    street: 'ul. Spółdzielcza 27',
    email: 'gliwice@inter-team.com.pl',
  },
  {
    branch: 24,
    city: 'Kraków',
    postalCode: '31-752',
    street: 'ul. Wąwozowa 34B',
    email: 'nowahuta@inter-team.com.pl',
  },
  {
    branch: 25,
    city: 'Blizna Łaszczyńskiego',
    postalCode: '05-082',
    street: 'ul. Warszawska 35D',
    email: 'warszawa.zachod@inter-team.com.pl',
  },
  {
    branch: 26,
    city: 'Grodzisk Mazowiecki',
    postalCode: '05-825',
    street: 'ul. Logistyczna 15 Natolin',
    email: 'natolin@inter-team.com.pl',
  },
  {
    branch: 27,
    city: 'Piaseczno',
    postalCode: '05-500',
    street: 'ul. Techniczna 2',
    email: 'piaseczno@inter-team.com.pl',
  },
  {
    branch: 28,
    city: 'Gdynia',
    postalCode: '81-061',
    street: 'ul. Hutnicza 53',
    email: 'gdynia@inter-team.com.pl',
  },
  {
    branch: 29,
    city: 'Zgorzelec',
    postalCode: '59-900',
    street: 'ul. Andersa 4',
    email: 'zgorzelec@inter-team.com.pl',
  },
  {
    branch: 30,
    city: 'Wieliczka',
    postalCode: '32-020',
    street: 'ul. Reformacja 25',
    email: 'wieliczka@inter-team.com.pl',
  },
  {
    branch: 31,
    city: 'Strzelce Opolskie',
    postalCode: '47-100',
    street: 'ul. Kosielska 58',
    email: 'strzelceopolskie@inter-team.com.pl',
  },
  {
    branch: 32,
    city: 'Sokółka',
    postalCode: '16-100',
    street: 'ul. Mariańska 51',
    email: 'sokolka@inter-team.com.pl',
  },
  {
    branch: 33,
    city: 'Kętrzyn',
    postalCode: '11-400',
    street: 'ul. Kruszewiec 21a',
    email: 'ketrzyn@inter-team.com.pl',
  },
  {
    branch: 34,
    city: 'Białystok',
    postalCode: '15-688',
    street: 'ul. Przędzalniana 64',
    email: 'bialystok@inter-team.com.pl',
  },
  {
    branch: 35,
    city: 'Bydgoszcz',
    postalCode: '85-737',
    street: 'ul. Łęczycka 12',
    email: 'bydgoszcz2@inter-team.com.pl',
  },
  {
    branch: 36,
    city: 'Koszalin',
    postalCode: '75-129',
    street: 'ul. Mieszka I 4',
    email: 'koszalin@inter-team.com.pl',
  },
  {
    branch: 37,
    city: 'Siedlce',
    postalCode: '08-110',
    street: 'ul. Brzeska 180',
    email: 'siedlce@inter-team.com.pl',
  },
  {
    branch: 38,
    city: 'Zawiercie',
    postalCode: '42-400',
    street: 'ul. Wojska Polskiego 36',
    email: 'zawiercie@inter-team.com.pl',
  },
  {
    branch: 39,
    city: 'Inowrocław',
    postalCode: '88-100',
    street: 'ul. Poznańska 211',
    email: 'inowroclaw@inter-team.com.pl',
  },
  {
    branch: 40,
    city: 'Tarnowskie Góry',
    postalCode: '42-600',
    street: 'ul. Zagórska 194',
    email: 'tarnowskiegory@inter-team.com.pl',
  },
  {
    branch: 41,
    city: 'Kędzierzyn-Koźle',
    postalCode: '47-200',
    street: 'ul. Piastowska 26B',
    email: 'kedzierzyn@inter-team.com.pl',
  },
  {
    branch: 42,
    city: 'Malbork',
    postalCode: '82-200',
    street: 'ul. Pilotów 4',
    email: 'malbork@inter-team.com.pl',
  },
  {
    branch: 43,
    city: 'Wrocław',
    postalCode: '53-015',
    street: 'ul. Braterska 6',
    email: 'wroclaw@inter-team.com.pl',
  },
  {
    branch: 44,
    city: 'Świdnica',
    postalCode: '58-100',
    street: 'ul. Parkowa 8-10',
    email: 'swidnica@inter-team.com.pl',
  },
  {
    branch: 45,
    city: 'Łomża',
    postalCode: '18-400',
    street: 'ul. Aleja Legionów 114',
    email: 'lomza@inter-team.com.pl',
  },
  {
    branch: 46,
    city: 'Gorzów Wielkopolski',
    postalCode: '66-400',
    street: 'ul. Piłkarska 21',
    email: 'gorzow@inter-team.com.pl',
  },
  {
    branch: 47,
    city: 'Wołomin',
    postalCode: '05-200',
    street: 'ul. Armii Krajowej 19A',
    email: 'wolomin@inter-team.com.pl',
  },
  {
    branch: 48,
    city: 'Łódź',
    postalCode: '91-341',
    street: 'ul. Brukowa 16/18',
    email: 'lodz2@inter-team.com.pl',
  },
  {
    branch: 49,
    city: 'Tarnobrzeg',
    postalCode: '39-400',
    street: 'ul. Warszawska 2A',
    email: 'tarnobrzeg@inter-team.com.pl',
  },
  {
    branch: 50,
    city: 'Skórzewo',
    postalCode: '60-185',
    street: 'ul. Malwowa 134',
    email: 'poznan2@inter-team.com.pl',
  },
  {
    branch: 51,
    city: 'Rzeszów',
    postalCode: '35-205',
    street: 'ul. Wspólna 2',
    email: 'rzeszow@inter-team.com.pl',
  },
  {
    branch: 52,
    city: 'Łowicz',
    postalCode: '99-400',
    street: 'ul. Poznańska 42',
    email: 'lowicz@inter-team.com.pl',
  },
  {
    branch: 53,
    city: 'Legnica',
    postalCode: '59-220',
    street: 'ul. Wrocławska 104',
    email: 'legnica@inter-team.com.pl',
  },
  {
    branch: 54,
    city: 'Mielec',
    postalCode: '39-300',
    street: 'ul. Kocjana 4',
    email: 'mielec@inter-team.com.pl',
  },
  {
    branch: 55,
    city: 'Nowy Sącz',
    postalCode: '33-300',
    street: 'ul. Węgierska 201',
    email: 'nowysacz@inter-team.com.pl',
  },
  {
    branch: 56,
    city: 'Sosnowiec',
    postalCode: '41-219',
    street: 'ul. Piękna 2',
    email: 'sosnowiec@inter-team.com.pl',
  },
  {
    branch: 57,
    city: 'Krosno',
    postalCode: '38-400',
    street: 'ul. Podkarpacka 2',
    email: 'krosno@inter-team.com.pl',
  },
  {
    branch: 58,
    city: 'Zamość',
    postalCode: '22-400',
    street: 'ul. Lubelska 66',
    email: 'zamosc@inter-team.com.pl',
  },
  {
    branch: 59,
    city: 'Wyszków',
    postalCode: '07-200',
    street: 'ul. Świętojańska 175',
    email: 'wyszkow@inter-team.com.pl',
  },
  {
    branch: 60,
    city: 'Żywiec',
    postalCode: '34-300',
    street: 'ul. Dworcowa 22',
    email: 'zywiec@inter-team.com.pl',
  },
  {
    branch: 61,
    city: 'Lublin',
    postalCode: '20-704',
    street: 'ul. Wojciechowska 21B',
    email: 'lublin@inter-team.com.pl',
  },
  {
    branch: 62,
    city: 'Toruń',
    postalCode: '87-100',
    street: 'ul. Marii Curie-Skłodowskiej 81A',
    email: 'torun@inter-team.com.pl',
  },
  {
    branch: 63,
    city: 'Nowy Targ',
    postalCode: '34-400',
    street: 'ul. Składowa 7A',
    email: 'nowytarg@inter-team.com.pl',
  },
  {
    branch: 64,
    city: 'Tarnów',
    postalCode: '33-100',
    street: 'ul. Wyszyńskiego 12F',
    email: 'tarnow@inter-team.com.pl',
  },
  {
    branch: 65,
    city: 'Ostrołęka',
    postalCode: '07-401',
    street: 'ul. Wojska Polskiego 22',
    email: 'ostroleka@inter-team.com.pl',
  },
  {
    branch: 66,
    city: 'Kłodzko',
    postalCode: '57-300',
    street: 'ul. Warszawy-Centrum 18A',
    email: 'klodzko@inter-team.com.pl',
  },
  {
    branch: 67,
    city: 'Zielona Góra',
    postalCode: '65-155',
    street: 'ul. Dekoracyjna 3B',
    email: 'zielonagora@inter-team.com.pl',
  },
  {
    branch: 68,
    city: 'Płock',
    postalCode: '09-407',
    street: 'ul. Graniczna 46',
    email: 'plock@inter-team.com.pl',
  },
  {
    branch: 69,
    city: 'Grudziądz',
    postalCode: '86-300',
    street: 'ul. Józefa Włodka 16F',
    email: 'grudziadz@inter-team.com.pl',
  },
  {
    branch: 70,
    city: 'Jelenia Góra',
    postalCode: '58-500',
    street: 'ul. Okopowa 18',
    email: 'jeleniagora@inter-team.com.pl',
  },
  {
    branch: 71,
    city: 'Tychy',
    postalCode: '43-100',
    street: 'ul. Mysłowicka 1',
    email: 'tychy@inter-team.com.pl',
  },
  {
    branch: 72,
    city: 'Zduńska Wola',
    postalCode: '98-220',
    street: 'ul. Wodna 4/6',
    email: 'zdunskawola@inter-team.com.pl',
  },
  {
    branch: 73,
    city: 'Stargard',
    postalCode: '73-110',
    street: 'ul. Pierwszej Brygady 15E',
    email: 'stargard@inter-team.com.pl',
  },
  {
    branch: 74,
    city: 'Elbląg',
    postalCode: '82-300',
    street: 'ul. Malborska 91',
    email: 'elblag@inter-team.com.pl',
  },
  {
    branch: 75,
    city: 'Bytom',
    postalCode: '41-905',
    street: 'ul. Św. Elżbiety 3',
    email: 'bytom@inter-team.com.pl',
  },
  {
    branch: 76,
    city: 'Międzyrzecze Górne',
    postalCode: '43-392',
    street: 'ul. Przemysłowa 370',
    email: 'bielskobiala@inter-team.com.pl',
  },
  {
    branch: 77,
    city: 'Kalisz',
    postalCode: '62-800',
    street: 'ul. Warszawska 40',
    email: 'kalisz@inter-team.com.pl',
  },
  {
    branch: 78,
    city: 'Rybnik',
    postalCode: '44-203',
    street: 'ul. Karola Miarki 13',
    email: 'rybnik@inter-team.com.pl',
  },
  {
    branch: 79,
    city: 'Kutno',
    postalCode: '99-300',
    street: 'ul. Spółdzielcza 7',
    email: 'kutno@inter-team.com.pl',
  },
  {
    branch: 82,
    city: 'Suwałki',
    postalCode: '16-400',
    street: 'ul. Sejneńska 24',
    email: 'suwalki@inter-team.com.pl',
  },
  {
    branch: 83,
    city: 'Ełk',
    postalCode: '19-300',
    street: 'ul. Tadeusza Kościuszki 26A',
    email: 'elk@inter-team.com.pl',
  },
  {
    branch: 84,
    city: 'Chojnice',
    postalCode: '89-600',
    street: 'ul. Marynarki 3',
    email: 'chojnice@inter-team.com.pl',
  },
  {
    branch: 85,
    city: 'Sulbiny',
    postalCode: '08-400',
    street: 'ul. Wspólna 2',
    email: 'garwolin@inter-team.com.pl',
  },
  {
    branch: 86,
    city: 'Janki',
    postalCode: '05-090',
    street: 'ul. Aleja Krakowska 10',
    email: 'janki@inter-team.com.pl',
  },
  {
    branch: 87,
    city: 'Leszno',
    postalCode: '64-100',
    street: 'ul. Luksemburska 5',
    email: 'leszno@inter-team.com.pl',
  },
  {
    branch: 88,
    city: 'Skierniewice',
    postalCode: '96-100',
    street: 'ul. Marii Skłodowskiej – Curie 124',
    email: 'skierniewice@inter-team.com.pl',
  },
  {
    branch: 89,
    city: 'Gniezno',
    postalCode: '62-200',
    street: 'ul. Podkomorska 5',
    email: 'gniezno@inter-team.com.pl',
  },
  {
    branch: 90,
    city: 'Wejherowo',
    postalCode: '84-200',
    street: 'ul. Brygady Pancernej Wojska Polskiego 9',
    email: 'wejherowo@inter-team.com.pl',
  },
  {
    branch: 90,
    city: 'Włocławek',
    postalCode: '87-800',
    street: 'ul. Kruszyńska 43',
    email: 'wloclawek@inter-team.com.pl',
  },
]

const InterTeamBranchSelect = props => {
  const [value, setValue] = React.useState(props.value);

  useAfterUpdateEffect(() => props.onChange(value), [value])

  const getOptions = () => {
    return branches.map(branch => ({
      label: `${branch.city} (${branch.branch}), ${branch.street}`,
      value: branch.branch,
    }))
  }

  return <Select
    placeholder="Wybierz oddział..."
    options={getOptions()}
    value={value}
    onChange={value => setValue(value)}
  />;
};

InterTeamBranchSelect.propTypes = {

};

export default InterTeamBranchSelect;
